import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api from "../lib/api";

export const ForumBadge = ({ testid = "forum-badge-link" }) => {
  const nav = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () => {
      api.get("/forum/unread-count").then((r) => { if (alive) setUnread(r.data?.unread || 0); }).catch(() => {});
    };
    load();
    const iv = setInterval(load, 45000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  return (
    <button
      data-testid={testid}
      onClick={() => nav("/forum")}
      className="relative w-10 h-10 rounded-xl bg-white border border-[#E2DFD8] flex items-center justify-center hover:border-[#F26419] transition-colors"
      title="Forum"
    >
      <MessageCircle className="w-5 h-5 text-[#3B423E]" />
      {unread > 0 && (
        <span
          data-testid="forum-badge-count"
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F26419] text-white text-[10px] font-black flex items-center justify-center border-2 border-white"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
};
